<template>
  <div class="content">
      <div class="title">电子证件</div>
		<div class="wrapper">
			<!-- <watermark></watermark> -->
			<div class="logoArea">
				<div class="schoolLogo"></div>
				<div class="schoolMotto">学生证</div>
			</div>
			<div class="contentArea">
				<div class="left">
					<p class="name">姓名：{{ studentData.XM }}<span class="sex">性别：{{ studentData.XBM === '1' ? '男' : '女' }}</span></p>
					<p class="studentNum">学号：{{ studentData.XH }}</p>
					<p class="department">系别：{{ studentData.YXMC }}</p>
					<p class="major">专业：{{ studentData.ZYMC }}</p>
					<p class="endDate">有效期：{{ studentData.ZJYXQ }}</p>
				</div>
				<div class="right">
					<img
            id="headphoto"
            :src="
               studentData.TXDZ ? 'data:image/jpg;base64,'+ studentData.TXDZ : require('@/assets/zhicheng/default.png')
            "
            alt=""
          />
					<p class="idNum">证件号 {{ studentData.SFZJH }}</p>
				</div>
			</div>
		</div>
		<div class="qrcodeArea">
			<div class="barcodeimg" :class="this.isFangda?'fangda':''">
				<svg id="barcode" @click="fangda"></svg>
			</div>
			<!-- <p class="tip">用于学校图书馆</p> -->
			<div class="qrimg" :class="this.qrBig?'qrBig':''">
				<!-- <tki-qrcode ref="qrcode" :val="val" :size="size" :unit="unit" :onval="onval" :loadMake="loadMake" @change="navToEnlargeImage" /> -->
                <div id="qrCode" ref="qrCodeDiv" @click="navToEnlargeImage"></div>
			</div>
			<!-- <div class="foot">
				<p>用于学校图书馆出入口，出示二维码进行事项办理</p>
			</div> -->
		</div>
	</div>
</template>

<script>
import Watermark from "../../../utils/warterMark";
import JsBarcode from "jsbarcode";
import QRCode from "qrcodejs2";
import { getStudentElectronicDocuments } from "@/api/zhicheng.js";
export default {
data() {
    return {
        studentData: {}, // 学生数据
        defaultHeadPhoto: '../../static/default.png', // 默认头像../../static/default.png
        val: '', //二维码值 学号
        barcodeValue: '', //条形码 S + 学号
        size: 127, //二维码大小
        unit: 'px', //二维码大小的单位
        loadMake: true, //加载动画
        onval: true,
        opations: { //条形码的属性
            width: 2.5,
            height: 60,
            displayValue: false,
            marginTop: 18,
            text: '' // 条码内容（会覆盖val属性）
        },
        isFangda:false,
        qrBig: false,
        username: ''
    }
},
created() {
    this.nowTimes();
    this.handleUrlInfo();
  },
  mounted() {
    //水印生成
    Watermark.set(this.updateTime, this.$refs.waterMark);
    this.handStudentElectronicDocuments();
  },
  methods: {
    handStudentElectronicDocuments() {
        let username = 'eyJhbGciOiJSUzUxMiJ9.eyJzdWIiOiIyMTE3MTcxMTciLCJpc3MiOiJ1aXMuZmR6Y3h5LmVkdS5jbiIsIkFUVFJfaWRlbnRpdHlUeXBlSWQiOiI1MWMwNmZhMGRmYjYxMWViYjk3NmVhOTVmZDNkZjM0NCIsIkFUVFJfYWNjb3VudElkIjoiOTlkZDc5ZjBlMGEwMTFlYmI5NzZlYTk1ZmQzZGYzNDQiLCJBVFRSX3VzZXJJZCI6Ijk5ZDBjZmMwZTBhMDExZWJiOTc2ZWE5NWZkM2RmMzQ0IiwiQVRUUl9uYW1lIjoi6b2Q5b-XIiwiQVRUUl9pZGVudGl0eVR5cGVDb2RlIjoiUzAxIiwiQVRUUl9pZGVudGl0eVR5cGVOYW1lIjoi5a2m55SfIiwiQVRUUl9vcmdhbml6YXRpb25OYW1lIjoi5Lyg5pKt5LiO6Im65pyv57O7IiwiQVRUUl91c2VyTmFtZSI6Ium9kOW_lyIsImV4cCI6MTYyOTYyMjM2OCwiQVRUUl9vcmdhbml6YXRpb25JZCI6IjIxMzAyMDAwIiwiaWF0IjoxNjI5NDQ5NTY4LCJqdGkiOiJJRC1Ub2tlbi0yMzUtcjV1WVJvRG8tdUF1enhQRTlKYmxZTEsyZmowS3hUdWoiLCJyZXEiOiJwb3J0YWwtdWkiLCJBVFRSX29yZ2FuaXphdGlvbkNvZGUiOiIyMTMwMjAwMCJ9.N1PQvgxKEwHwFW8h8MBfzPeuLOZ6mtWXlZ8gkjfsmoiR6rWN-POxxeXfPgo6kIfZYiJKiWaoKCBIK4-dbdy7VUlrKAH6_9Hx6YANLL26oVDsW7fVuN9dT7yk6z29AfMpS5oO7w9bfin1nkZg_sV537_bFUg0ks98OnrwhNJ3qS0';
        let data ={
            username: this.username
        }
      getStudentElectronicDocuments(data).then((res) => {
        console.log(res);
        if (res) {
          this.studentData = res;
          this.val = res.XH; //二维码值 学号
          var mycode = "S" + res.XH; // 条形码的值 S + 学号
          JsBarcode("#barcode", mycode, {
            format: "CODE128",
            lineColor: "#000",
            width: 2.5,
            height: 60,
            displayValue: false,
          });
          new QRCode(this.$refs.qrCodeDiv, {
            text: this.val,
            width: 152,
            height: 150,
            colorDark: "#333333", //二维码颜色
            colorLight: "#ffffff", //二维码背景色
            correctLevel: QRCode.CorrectLevel.L, //容错率，L/M/H
          });
        }
      });
    },
    navToEnlargeImage(data) {
    //   uni.navigateTo({
    //     url: "/pages/index/enlargeImage?data=" + encodeURIComponent(data),
    //   });
        // this.$router.push()
        this.qrBig = this.qrBig ? false : true;
    },
    fangda() {
      this.isFangda = this.isFangda ? false : true;
    },
    nowTimes() {
      this.timeFormate(new Date());
    },
    timeFormate(timeStamp) {
      let year = new Date(timeStamp).getFullYear();
      let month =
        new Date(timeStamp).getMonth() + 1 < 10
          ? "0" + (new Date(timeStamp).getMonth() + 1)
          : new Date(timeStamp).getMonth() + 1;
      let date =
        new Date(timeStamp).getDate() < 10
          ? "0" + new Date(timeStamp).getDate()
          : new Date(timeStamp).getDate();
      let hh =
        new Date(timeStamp).getHours() < 10
          ? "0" + new Date(timeStamp).getHours()
          : new Date(timeStamp).getHours();
      let mm =
        new Date(timeStamp).getMinutes() < 10
          ? "0" + new Date(timeStamp).getMinutes()
          : new Date(timeStamp).getMinutes();
      let ss =
        new Date(timeStamp).getSeconds() < 10
          ? "0" + new Date(timeStamp).getSeconds()
          : new Date(timeStamp).getSeconds();
      this.updateTime =
        year + "/" + month + "/" + date + " " + hh + ":" + mm + ":" + ss;
    },
    handleUrlInfo() {
        let urlInfo = window.location.href;
        let urlParams = urlInfo.split("?");
        // let urlParamsList = urlParams[1].split("&");
        // this.type = urlParamsList[0].split("=")[1];
        this.username = urlParams[1].split("=")[1];
    },
  },
}
</script>

<style lang="scss" scoped>
uni-page-body {
		height: 100%;
	}

	.content {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: flex-start;
		background-color: #1374DF;
        width: 100%;
		height: auto;
		min-height: 100vh;
		position: relative;
        .title {
            background: rgb(19, 116, 223);
            color: #fff;
            width: 100%;
            height: 44px;
            line-height: 44px;
            text-align: center;
        }
	}

	.logo {
		height: 200px;
		width: 200px;
		margin-top: 200px;
		margin-left: auto;
		margin-right: auto;
		margin-bottom: 50px;
	}

	.text-area {
		display: flex;
		justify-content: center;
	}

	// .title {
	// 	font-size: 36px;
	// 	color: #8f8f94;
	// }

	.content .wrapper {
		width: 92%;
		min-height: 32.4%;
		background-color: #fff;
		position: relative;
		top: 15px;
		border-radius: 10px;
	}

	.content .wrapper .logoArea {
		width: 100%;
		margin-top: 13px;
		height: 32px;
		display: inline-flex;
		justify-content: flex-start;
		flex-direction: row;
		position: relative;
	}

	.content .wrapper .logoArea .schoolLogo {
		width: 204px;
		height: 32px;
		background: url(../../../assets/zhicheng/schoolLogo.png) no-repeat center;
		background-size: auto 100%;
		margin-left: 25px;
	}

	.content .wrapper .logoArea .schoolMotto {
		width: 106px;
		height: 23px;
		/* background: url(../../static/schoolMotto.png) no-repeat right;
		background-size: auto 100%; */
		color: rgba(23, 145, 181, 1);
		font-size: 19px;
		text-align: center;
		position: absolute;
		right: 0px;
		top: 4px;
	}

	.content .wrapper .contentArea {
		width: 100%;
		min-height: 138px;
		margin-top: 10px;
		position: relative;
		margin-bottom: 15px;
		/* 		display: flex;
		flex-direction: row;
		justify-content: flex-start; */
	}

	.content .wrapper .contentArea .left {
		width: 215px;
		height: 100%;
		padding-left: 25px;
		color: rgba(51, 51, 51, 1);
	}

	.left .name {
		margin-top: 10px;
		position: relative;
	}

	.left .name span {
		position: relative;
		left: 45px;
	}

	.left p {
		font-size: 13px;
		margin-top: 5px;
	}

	.left .endDate {
		position: absolute;
		bottom: 0px;
	}

	.content .wrapper .contentArea .right {
		width: 88px;
		height: 100%;
		color: rgba(51, 51, 51, 1);
		position: absolute;
		right: 12px;
		top: 0px;
	}

	.right #headphoto {
		width: 84px;
		height: 115px;
	}

	.right .idNum {
		font-size: 12px;
		transform: scale(0.8);
		width: 135%;
		position: relative;
		left: -20px;
		bottom: 5px;
		text-align: center;
        /* white-space: nowrap; */
	}

	.content .qrcodeArea {
		width: 92%;
		min-height: 44.73%;
		margin-top: 30px;
		background-color: #fff;
		border-radius: 10px;
		margin-bottom: 15px;
	}

	.content .qrcodeArea .barcodeimg {
		/* width: 90%; */
		margin: 0 auto;
		text-align: center;
		margin-top: 10px;
	}

	.content .qrcodeArea .tip {
		color: rgba(153, 153, 153, 1);
		font-size: 12px;
		text-align: center;
	}

	.content .qrcodeArea .qrimg {
		/* padding-left: 30%; */
		margin: 15px auto;
		text-align: center;
        display: flex;
        justify-content: center;
	}

	.content .qrcodeArea .foot {
		height: 40px;
		line-height: 40px;
		color: rgba(51, 51, 51, 1);
		background: #F5F5F5;
		border-radius: 0px 0px 10px 10px;
		text-align: center;
	}

	.foot p {
		font-size: 13px;
	}
	.fangda{
		position: absolute;
		top: 0;
		left: 0;
		z-index: 99999;
		width: 100%!important;
		height: 100vh;
		background-color: #fff;
	}
	.fangda #barcode{
		position: relative;
		margin-top: 60%;
		transform: scale(1.2)!important;
	}

    .qrBig{
        position: absolute;
        top: 0;
        left: 0;
        z-index: 99999;
        width: 100%!important;
        height: 100vh;
        background: #fff;
        display: flex;
        justify-content: center;
        align-items: center;
    }

	@media screen and (max-width: 320px) {
		.content .wrapper .logoArea .schoolLogo {
			width: 204px;
			height: 32px;
			background: url(/static/img/schoolLogo.cbf6e838.png) no-repeat center;
			background-size: auto 100%;
			margin-left: 0px;
			transform: scale(0.9);
			position: relative;
			left: -5px;
		}

		.content .wrapper .contentArea .left {
			padding-left: 8px;
		}

		.content .wrapper .contentArea .right {
			right: 3px;
		}

		.left .tip {
			font-size: 11px;
			-webkit-transform: scale(0.9);
			transform: scale(0.8);
			position: relative;
			left: -25px;
		}

		.barcodeimg {
			transform: scale(0.8);
		}

		.barcodeimg .tki-barcode {
			left: -20px;
		}
	}
</style>